webpackJsonp([114276838955818,60335399758886],{

/***/ 103:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"RadWorks","description":"Web development and consulting for startups and entrepreneurs"}}},"layoutContext":{}}

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(203);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(103);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  serifId: "Layer 1",
	  fillRule: "nonzero"
	}, _react2.default.createElement("path", {
	  d: "M206.242 74.211c4.336 0 7.786-1.036 10.349-3.108 2.562-2.073 3.843-4.886 3.843-8.439v-.196c0-3.749-1.249-6.596-3.745-8.537-2.497-1.942-6.013-2.911-10.548-2.911h-17.643v23.191h17.744zm-29.732-34.1h30.659c4.324 0 8.156.607 11.497 1.819 3.342 1.213 6.125 2.898 8.353 5.06a19.956 19.956 0 0 1 4.226 6.584c.982 2.491 1.474 5.242 1.474 8.254v.197c0 2.818-.411 5.355-1.229 7.616-.82 2.259-1.95 4.259-3.391 5.994a20.378 20.378 0 0 1-5.158 4.423c-2 1.212-4.21 2.145-6.634 2.799l18.574 26.041h-14.249l-16.954-23.977h-15.18v23.977H176.51V40.111zM287.266 81.58l-11.891-27.515-11.791 27.515h23.682zm-17.295-41.959h11.202l30.267 69.277h-12.776l-6.976-16.607h-32.526l-7.076 16.607h-12.381l30.266-69.277zM344.122 97.99c3.602 0 6.879-.574 9.826-1.726 2.948-1.151 5.454-2.762 7.518-4.835 2.063-2.072 3.668-4.54 4.815-7.402 1.146-2.862 1.72-5.97 1.72-9.324v-.198c0-3.356-.574-6.48-1.72-9.374-1.147-2.895-2.752-5.377-4.815-7.45-2.064-2.072-4.57-3.7-7.518-4.885-2.947-1.184-6.224-1.777-9.826-1.777H330.56V97.99h13.562zm-25.55-57.879h25.648c5.371 0 10.301.869 14.789 2.604 4.487 1.737 8.353 4.145 11.595 7.223 3.244 3.079 5.75 6.699 7.518 10.859 1.768 4.16 2.653 8.664 2.653 13.511v.197c0 4.848-.885 9.369-2.653 13.561-1.768 4.194-4.274 7.828-7.518 10.907-3.242 3.08-7.108 5.503-11.595 7.271-4.488 1.769-9.418 2.654-14.789 2.654h-25.648V40.111zM382.249 40.111h13.069l16.413 51 16.901-51.196h10.22l16.9 51.196 16.413-51h12.676l-23.979 69.278h-10.416l-16.901-49.428-16.902 49.428h-10.416l-23.978-69.278zM522.329 98.974c3.392 0 6.507-.639 9.344-1.916 2.838-1.278 5.267-3.014 7.289-5.209 2.022-2.193 3.603-4.766 4.747-7.714 1.141-2.947 1.712-6.093 1.712-9.433v-.197c0-3.341-.571-6.501-1.712-9.483-1.144-2.98-2.741-5.568-4.797-7.763-2.053-2.193-4.517-3.945-7.385-5.257-2.873-1.309-6.003-1.966-9.394-1.966-3.395 0-6.507.639-9.345 1.917-2.837 1.278-5.268 3.014-7.291 5.208-2.022 2.196-3.603 4.767-4.746 7.714-1.142 2.948-1.711 6.093-1.711 9.434v.196c0 3.341.569 6.502 1.711 9.484 1.143 2.981 2.741 5.569 4.796 7.762 2.054 2.196 4.516 3.948 7.389 5.257 2.869 1.311 6 1.966 9.393 1.966m-.196 11.104c-5.307 0-10.155-.934-14.544-2.801-4.389-1.866-8.156-4.405-11.301-7.615-3.144-3.209-5.601-6.96-7.369-11.252-1.771-4.291-2.655-8.859-2.655-13.708v-.197c0-4.847.884-9.416 2.655-13.708 1.768-4.291 4.258-8.058 7.467-11.3 3.209-3.243 7.009-5.814 11.399-7.714 4.389-1.9 9.237-2.85 14.544-2.85s10.154.934 14.543 2.801c4.39 1.866 8.157 4.405 11.302 7.614 3.144 3.211 5.6 6.963 7.368 11.253 1.77 4.292 2.654 8.86 2.654 13.708v.196c0 4.849-.884 9.418-2.654 13.708-1.768 4.292-4.258 8.059-7.467 11.301-3.211 3.242-7.012 5.815-11.398 7.714-4.39 1.899-9.238 2.85-14.544 2.85M598.678 74.211c4.335 0 7.785-1.036 10.349-3.108 2.561-2.073 3.843-4.886 3.843-8.439v-.196c0-3.749-1.249-6.596-3.746-8.537-2.497-1.942-6.012-2.911-10.546-2.911h-17.643v23.191h17.743zm-29.732-34.1h30.659c4.324 0 8.156.607 11.497 1.819 3.341 1.213 6.124 2.898 8.352 5.06a19.921 19.921 0 0 1 4.225 6.584c.984 2.491 1.475 5.242 1.475 8.254v.197c0 2.818-.41 5.355-1.229 7.616-.819 2.259-1.949 4.259-3.39 5.994a20.365 20.365 0 0 1-5.159 4.423c-1.999 1.212-4.21 2.145-6.633 2.799l18.573 26.041h-14.248l-16.955-23.977H580.935v23.977h-11.989V40.111zM636.229 40.111h11.987v34.59l32.724-34.59h14.838L667.183 69.69l29.873 39.208h-14.641l-23.487-30.954-10.712 11.006v19.948h-11.987V40.111zM726.829 109.881c-5.307 0-10.384-.9-15.231-2.702-4.85-1.802-9.335-4.569-13.464-8.303l7.273-8.648c3.34 2.883 6.714 5.094 10.121 6.633 3.404 1.54 7.271 2.309 11.595 2.309 3.734 0 6.697-.786 8.894-2.358 2.193-1.573 3.291-3.668 3.291-6.289v-.198c0-1.243-.212-2.339-.639-3.291-.428-.949-1.218-1.85-2.366-2.702-1.149-.85-2.727-1.637-4.728-2.358-2.005-.721-4.615-1.441-7.833-2.162-3.679-.851-6.945-1.819-9.802-2.899-2.857-1.082-5.254-2.391-7.192-3.931a15.179 15.179 0 0 1-4.434-5.65c-1.017-2.226-1.526-4.914-1.526-8.058v-.197c0-2.948.583-5.65 1.754-8.106a18.655 18.655 0 0 1 4.823-6.289c2.048-1.736 4.508-3.097 7.386-4.078 2.876-.983 6.016-1.475 9.424-1.475 5.044 0 9.581.737 13.609 2.211 4.03 1.474 7.814 3.621 11.352 6.437l-6.487 9.138c-3.144-2.292-6.256-4.044-9.336-5.257-3.079-1.211-6.19-1.818-9.335-1.818-3.538 0-6.288.786-8.255 2.358-1.963 1.573-2.948 3.505-2.948 5.798v.198c0 1.31.23 2.472.691 3.488.458 1.016 1.296 1.932 2.511 2.751 1.215.82 2.891 1.589 5.024 2.309 2.135.721 4.844 1.474 8.129 2.26 3.61.918 6.814 1.934 9.605 3.047 2.791 1.114 5.105 2.473 6.946 4.078 1.837 1.606 3.234 3.472 4.187 5.601.95 2.129 1.43 4.602 1.43 7.419v.196c0 3.211-.603 6.093-1.806 8.647a18.522 18.522 0 0 1-5.019 6.487c-2.142 1.767-4.719 3.112-7.728 4.028-3.01.917-6.314 1.376-9.916 1.376",
	  fill: "#333"
	}), _react2.default.createElement("path", {
	  d: "M74.4 35.015c-21.774 0-39.489 17.716-39.489 39.49 0 21.775 17.715 39.49 39.489 39.49 21.775 0 39.49-17.715 39.49-39.49 0-21.774-17.715-39.49-39.49-39.49m0 86.557c-25.952 0-47.065-21.115-47.065-47.067S48.448 27.439 74.4 27.439c25.953 0 47.066 21.114 47.066 47.066s-21.113 47.067-47.066 47.067m-6.643 19.055h13.286l1.738-11.155 2.591-.519a54.956 54.956 0 0 0 19.763-8.193l2.2-1.466 9.123 6.665 9.396-9.396-6.663-9.123 1.465-2.2a55 55 0 0 0 8.192-19.762l.519-2.592 11.156-1.736V67.863l-11.156-1.738-.519-2.591a55.016 55.016 0 0 0-8.192-19.764l-1.465-2.2 6.663-9.121-9.396-9.396-9.12 6.663-2.2-1.465a54.998 54.998 0 0 0-19.765-8.194l-2.592-.519-1.738-11.155H67.757L66.02 19.538l-2.592.519a54.993 54.993 0 0 0-19.764 8.194l-2.201 1.464-9.122-6.662-9.395 9.395 6.664 9.122-1.465 2.2a54.97 54.97 0 0 0-8.192 19.763l-.52 2.592-11.155 1.737V81.15l11.155 1.736.52 2.592a54.964 54.964 0 0 0 8.193 19.762l1.465 2.201-6.665 9.122 9.395 9.395 9.122-6.665 2.201 1.465a54.951 54.951 0 0 0 19.764 8.195l2.592.519 1.737 11.155zm19.775 7.576H61.269l-1.931-12.4a62.432 62.432 0 0 1-17.627-7.309l-10.139 7.41-18.57-18.572 7.408-10.14a62.39 62.39 0 0 1-7.308-17.624l-12.4-1.931V61.373l12.4-1.93a62.365 62.365 0 0 1 7.308-17.624l-7.408-10.141 18.57-18.57 10.139 7.408a62.453 62.453 0 0 1 17.627-7.31L61.269.807h26.263l1.929 12.399a62.382 62.382 0 0 1 17.628 7.31l10.138-7.408 18.57 18.57-7.406 10.141a62.445 62.445 0 0 1 7.308 17.624l12.4 1.93v26.264l-12.4 1.931a62.463 62.463 0 0 1-7.308 17.625l7.406 10.139-18.57 18.572-10.14-7.41a62.348 62.348 0 0 1-17.626 7.309l-1.929 12.4z",
	  fill: "#f48331"
	}), _react2.default.createElement("path", {
	  d: "M48.705 75.73l10.889 5.723v7.09L42.02 79.375v-7.089l17.574-9.217v7.09L48.705 75.73zM79.097 54.916l6.481 2.229-14.331 35.45-6.482-2.229 14.332-35.45zM88.714 70.159v-7.09l17.573 9.217v7.09l-17.573 9.167v-7.09l10.889-5.723-10.889-5.571z",
	  fill: "#f48331"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 752 149",
	    xmlnsSerif: "http://www.serif.com/",
	    fillRule: "evenodd",
	    clipRule: "evenodd",
	    strokeLinejoin: "round",
	    strokeMiterlimit: 1.414
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(286);
	var isArguments = __webpack_require__(285);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 285:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(40);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(54);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(53);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(127);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(126);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(418);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(284);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(400);
	
	var _HelmetConstants = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(293);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(437);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 437:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(98);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(306);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _header = __webpack_require__(330);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _radworksLogoHorizontal = __webpack_require__(207);
	
	var _radworksLogoHorizontal2 = _interopRequireDefault(_radworksLogoHorizontal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'header',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        _react2.default.createElement('img', { src: _radworksLogoHorizontal2.default, alt: 'RadWorks logo' })
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(399);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _global = __webpack_require__(332);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _header = __webpack_require__(201);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: data.site.siteMetadata.title,
	      meta: [{ name: 'description', content: data.site.siteMetadata.description }]
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(_header2.default, { siteTitle: data.site.siteMetadata.title }),
	      _react2.default.createElement(
	        'main',
	        null,
	        children()
	      )
	    )
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-2465172cbd06d1db0f29.js